import axios from "axios";
import { API_URL } from "../apiurl";
import { GET_EXCEL_DATA_BY_REPORT_QUERY } from "./query";

export const getExcelDataByReportAPI = async (reportId, tableId = null) => {
  try {
    const response = await axios.post(
      `${API_URL}/graphql`,
      {
        query: GET_EXCEL_DATA_BY_REPORT_QUERY,
        variables: { reportId, tableId },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.getExcelDataByReport;
  } catch (error) {
    console.error("Error fetching excel data:", error);
    return [];
  }
};
